import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Ohne explizite Anfrage duerfen Browser (auch iOS Safari) den lokalen
// Speicher einer Website (Cookies, localStorage - hier u.a. der Login-Token,
// siehe Webapp.js - UND Service-Worker-Registrierung/Push-Subscription)
// jederzeit automatisch raeumen, wenn sie ihn nicht als "dauerhaft"
// eingestuft haben (z.B. bei Speicherdruck oder nach einem Geraete-Neustart).
// Bugreport 2026-08-06: Login-Session UND Push-Subscription gleichzeitig weg
// nach einem iPhone-Neustart - genau das Muster eines kompletten Speicher-
// Raeumens, nicht eines Einzelfehlers. persist() bittet den Browser, das
// nicht zu tun. Kein Effekt, falls nicht unterstuetzt (z.B. Safari haelt sich
// laut oeffentlicher Dokumentation nicht immer strikt daran) - schadet aber
// nicht und ist der dafuer vorgesehene Standard-Mechanismus.
// In der nativen Capacitor-App ueberspringen: dort liegt der Speicher im
// eigenen App-Container ausserhalb von Safaris ITP-Zustaendigkeit (siehe
// project_capacitor_native_app), persist() ist wirkungslos und WKWebView
// lehnt die Anfrage ohnehin ab - das erzeugte nur eine verwirrende
// "Persistent Storage: abgelehnt"-Meldung beim App-Start.
const isNativeApp = !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
if (!isNativeApp && navigator.storage && navigator.storage.persist) {
	navigator.storage.persist().then((granted) => {
		console.log('Persistent Storage: ' + (granted ? 'gewaehrt' : 'abgelehnt'));
	}).catch(() => {});
}

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		// updateViaCache:'none' - service-worker.js wird auf dem Server ohne
		// Cache-Control-Header ausgeliefert (kein mod_headers im Apache-Image),
		// Browser duerfen die Datei also nach eigenem Ermessen zwischenspeichern
		// und eine Update-Pruefung dadurch stillschweigend aus dem eigenen Cache
		// beantworten, ohne den Server je zu fragen - "App schliessen und neu
		// oeffnen" half dadurch bei einem Mitglied nachweislich NICHT (Bugreport
		// 2026-08-05, Service-Worker-Fix kam nie an). Dieses Flag erzwingt, dass
		// der Service-Worker-Script IMMER frisch vom Netz geholt wird.
		navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' }).catch((error) => {
			console.error('Service-Worker-Registrierung fehlgeschlagen:', error);
		});
	});
}

// Wird eine installierte App (PWA) beendet und erneut geoeffnet, laedt der
// Browser die Seite oft nicht wirklich neu, sondern stellt einen eingefrorenen
// Zustand aus dem Back/Forward-Cache wieder her (event.persisted === true) -
// dabei laeuft unser Init-gesteuerter Start-Logik-Code (z.B. Startforum) nicht
// erneut. Ein erzwungener Reload in diesem Fall stellt sicher, dass die App
// immer frisch initialisiert wird, genau wie bei einem manuellen Reload.
window.addEventListener('pageshow', (event) => {
	if (event.persisted) {
		window.location.reload();
	}
});

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
      <App key="webapp">
      </App>
  </React.StrictMode>
);

